import React from 'react';

import cx from 'classnames';

import type { InProgressSize } from '../../types/common.types';

import './style.css';

export const InProgress: React.FC<{
  active?: boolean;
  inverted?: boolean;
  size?: InProgressSize;
  label?: string;
}> = ({ active = true, label, size = 'medium', inverted }) => (
  <svg
    className={cx(
      'in-progress',
      `in-progress--${size}`,
      !active && 'in-progress--inactive',
      inverted && 'in-progress--white'
    )}
    viewBox="0 0 100 100"
  >
    {label && <title>{label}</title>}
    <rect className="p p01" height="24" width="24" x="75" y="0" />
    <rect className="p p02" height="24" width="24" x="75" y="25" />
    <rect className="p p03" height="24" width="24" x="75" y="50" />
    <rect className="p p04" height="24" width="24" x="75" y="75" />

    <rect className="p p05" height="24" width="24" x="50" y="75" />
    <rect className="p p06" height="24" width="24" x="25" y="75" />

    <rect className="p p07" height="24" width="24" x="0" y="75" />
    <rect className="p p08" height="24" width="24" x="0" y="50" />
    <rect className="p p09" height="24" width="24" x="0" y="25" />
    <rect className="p p10" height="24" width="24" x="0" y="0" />

    <rect className="p p11" height="24" width="24" x="25" y="0" />
    <rect className="p p12" height="24" width="24" x="50" y="0" />
  </svg>
);
